// Phase 11-4 / 11a — CaregiverGuaranteePolicy read shapes.
// Mirror of 10b's CancellationPolicy read shape with one rename
// (chargePct → payPct per 11-4(a)).
import { z } from 'zod';
import { BuyerTypeSchema } from './enums.schema.js';
export const CaregiverGuaranteePolicyResponseSchema = z.object({
    id: z.string().uuid(),
    buyerType: BuyerTypeSchema,
    hoursBeforeThreshold: z.number().int().positive(),
    /** Renamed vs 10b's chargePct (what we charge buyer). This is what
     *  we PAY caregiver — semantically distinct, separate table per 11-4(a). */
    payPct: z.string(), // Prisma Decimal → string for transport safety
    effectiveFrom: z.string().date(),
    effectiveTo: z.string().date().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=caregiver-guarantee-policy.schema.js.map